export enum PropertyTypeEnum {
  // SOLD = '1',
  SALE = '2',
  RENT = '3',
}
